import React from 'react';

export default function Loader() {
    return (
        <div className="loader-page">
            <div className="spinner-content">
                <div className="bt-spinner"></div>
            </div>
            <div className="spinner-text">Carregando...</div>
        </div>
    );
}
